import { api } from "./api";

export const generateBillApi = (params) => {
    return api.post(`/billing/generate`, JSON.stringify(params));
};

export const listBillingApi = (params) => {
    return api.get(`/billing/list`, { params });
};

export const productDropdownApi = (params) => {
    return api.get(`/billing/products-list`, { params });
};

export const customersDropdownApi = (params) => {
    return api.get(`/billing/customers-list`, { params });
};

export const exportReportApi = (params) => {
    return api.get(`/billing/export`, { params });
};
